import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { toast } from 'sonner';

export default function CheckoutCancel() {
  const location = useLocation();
  const navigate = useNavigate();
  const { checkoutData } = location.state || {};

  useEffect(() => {
    if (!checkoutData) {
      toast.error('Informações de pagamento não encontradas');
      setTimeout(() => navigate('/'), 3000);
    }
  }, [checkoutData, navigate]);

  const handleGoToHome = () => {
    navigate('/');
    toast.info('Redirecionando…');
  };

  return (
    <div className="min-h-screen bg-muted/30 flex flex-col">
      <header className="py-4 bg-white border-b border-border">
        <div className="container px-4 mx-auto">
          <div className="flex items-center">
            <img src="/brand/logo-secundario.svg" alt="dgenny" className="h-9" />
          </div>
        </div>
      </header>

      <main className="container px-4 mx-auto py-12 flex-grow flex items-center justify-center">
        <div className="max-w-2xl w-full">
          <Card className="p-10 text-center border-border rounded-3xl">
            <div className="flex justify-center mb-6">
              <div className="w-20 h-20 bg-muted rounded-full flex items-center justify-center">
                <XCircle size={44} className="text-brand-azul/50" />
              </div>
            </div>

            <h1 className="font-display text-3xl md:text-4xl font-extrabold text-brand-azul mb-3">
              Pagamento cancelado
            </h1>

            <p className="text-brand-azul/70 mb-8 leading-relaxed">
              Sem drama. Quando quiser retomar, é só voltar para a seleção de planos.
            </p>

            <Button
              onClick={handleGoToHome}
              className="bg-brand-roxo hover:bg-brand-roxo/90 text-white py-3 px-8 rounded-full font-semibold text-base w-full"
            >
              Voltar para a home
            </Button>

            <p className="text-sm text-brand-azul/60 mt-4">
              Precisa de ajuda? <a href="mailto:compre.ai@dgenny.com.br" className="text-brand-roxo font-semibold hover:underline">Fale com a gente</a>
            </p>
          </Card>
        </div>
      </main>
    </div>
  );
}
